import Wrapper from './wrapper.vue'
import Header from './header.vue'
import Main from './main.vue'
import Footer from './footer.vue'
import Floating from './floating.vue'

export default { Wrapper, Header, Main, Footer, Floating }
